import {
  Box,
  useColorModeValue,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer
} from '@chakra-ui/react'
import { FC } from 'react'

import useOptimizerStorange from '@hook/optimizer/use-optimizer-storange'

// Interface para os dados do resumo
interface TradeOffResumeData {
  skusStkTotal: number
  custoMedioStkTotal: number
  skusStkASerOtimizado: number
  custoMedioStkASerOtimizado: number
  skusStkSemOtimizacao: number
  custoMedioStkSemOtimizacao: number
  skusStkOtimizado: number
  custoMedioStkOtimizado: string
}

// Interface para as props do componente
interface TradeOffResumeTableProps {
  dataTradeOffResume: TradeOffResumeData
  formatToBRL: (value: number) => string
  title?: string
}

// Componente funcional (FC)
const TradeOffResumeTable: FC<TradeOffResumeTableProps> = ({
  dataTradeOffResume,
  formatToBRL,
  title
}) => {
  const { selectedotimizer, dataTradeOffEstoque } = useOptimizerStorange()
  function calcularPercentualOtimizacao(
    custoMedioStkSemOtimizacao: number,
    custoMedioStkTotal: number,
    estoqueReais: number
  ): string {
    // Faz o cálculo e já subtrai 100
    const percentual =
      100 -
      ((custoMedioStkSemOtimizacao + estoqueReais) / custoMedioStkTotal) * 100

    // Formata para duas casas decimais
    return percentual.toFixed(2)
  }
  return (
    <Box
      shadow={'xl'}
      border={'1px solid'}
      borderColor={useColorModeValue('gray.800', 'gray.500')}
      rounded={'lg'}
      w="100%"
      h="100%"
    >
      <Box
        bg="#1d5840"
        color="white"
        width="100%"
        textAlign="center"
        py={2}
        roundedTop="lg"
      >
        <Box fontWeight="700" fontSize="xl" isTruncated>
          {title}
        </Box>
      </Box>
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th px={2} py={4} fontSize="16px">
                Resumo
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Stk Total
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Stk a ser Otimizado
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Stk sem Otimizacao
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Stk Otimizado
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Stk Total Estimado
              </Th>
              <Th px={2} py={4} fontSize="16px">
                Dif % Otimização
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            <Tr key={1}>
              <Td px={4} py={4} f>
                Skus
              </Td>{' '}
              <Td px={4} py={4} f>
                {dataTradeOffResume.skusStkTotal}
              </Td>{' '}
              <Td px={4} py={4} f>
                {dataTradeOffResume.skusStkASerOtimizado}
              </Td>{' '}
              <Td px={4} py={4} f>
                {dataTradeOffResume.skusStkSemOtimizacao}
              </Td>{' '}
              <Td px={4} py={4} f>
                {dataTradeOffResume.skusStkOtimizado}
              </Td>{' '}
              <Td px={4} py={4} f>
                {dataTradeOffResume.skusStkSemOtimizacao +
                  dataTradeOffResume.skusStkOtimizado}
              </Td>{' '}
              <Td px={4} py={4} f>
                {((dataTradeOffResume.skusStkSemOtimizacao +
                  dataTradeOffResume.skusStkOtimizado) /
                  dataTradeOffResume.skusStkTotal) *
                  100}{' '}
                %
              </Td>{' '}
              {/* Ajuste conforme necessário */}
            </Tr>
            <Tr key={1}>
              <Td px={4} py={4} f>
                Custo Medio
              </Td>{' '}
              <Td px={4} py={4} f>
                {formatToBRL(dataTradeOffResume.custoMedioStkTotal)}
              </Td>{' '}
              <Td px={4} py={4} f>
                {formatToBRL(dataTradeOffResume.custoMedioStkASerOtimizado)}
              </Td>{' '}
              <Td px={4} py={4} f>
                {formatToBRL(dataTradeOffResume.custoMedioStkSemOtimizacao)}
              </Td>{' '}
              <Td px={4} py={4} f>
                {selectedotimizer != null ? (
                  <>
                    {formatToBRL(
                      dataTradeOffEstoque[
                        selectedotimizer.level.replace(/Ponto\s*/, '')
                      ].estoqueReais || 0
                    )}
                  </>
                ) : (
                  '/'
                )}
              </Td>
              <Td px={4} py={4} f>
                {selectedotimizer != null ? (
                  <>
                    {formatToBRL(
                      dataTradeOffResume.custoMedioStkSemOtimizacao +
                        (dataTradeOffEstoque[
                          selectedotimizer.level.replace(/Ponto\s*/, '')
                        ].estoqueReais || 0)
                    )}
                  </>
                ) : (
                  '/'
                )}
              </Td>{' '}
              <Td px={4} py={4} f>
                {selectedotimizer != null ? (
                  <>
                    {calcularPercentualOtimizacao(
                      dataTradeOffResume.custoMedioStkSemOtimizacao,
                      dataTradeOffResume.custoMedioStkTotal,
                      parseFloat(selectedotimizer.level.replace(/Ponto\s*/, '')) // Garantir número
                        ? dataTradeOffEstoque[
                            parseFloat(
                              selectedotimizer.level.replace(/Ponto\s*/, '')
                            )
                          ]?.estoqueReais || 0
                        : 0 // Fallback para 0 se não for número válido
                    )}{' '}
                    %
                  </>
                ) : (
                  '/'
                )}
              </Td>{' '}
              {/* Ajuste conforme necessário */}
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default TradeOffResumeTable
